import ProgramRequestDetail from 'components/global/ProgramRequestDetail';

const LenderProgramRequestDetail = () => <ProgramRequestDetail />;
export default LenderProgramRequestDetail;
